import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-page">
      {/* Hero Section */}
      <div className="terms-hero">
        <div className="terms-hero-content">
          <h1>Terms of Service</h1>
          <p>Our terms and conditions for using our platform</p>
        </div>
      </div>

      <div className="terms-container">
        <div className="terms-content">
          <div className="terms-section">
            <h2>Acceptance of Terms</h2>
            <p>By accessing and using Inifiy, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
          </div>

          <div className="terms-section">
            <h2>Use License</h2>
            <p>Permission is granted to temporarily download one copy of the materials (information or software) on Inifiy's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>User Accounts</h2>
            <p>When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for all activities that occur under your account.</p>
          </div>

          <div className="terms-section">
            <h2>Product Information</h2>
            <p>We strive to provide accurate product information, but we do not warrant that product descriptions, colors, information, or other content available on the site is accurate, complete, reliable, current, or error-free.</p>
          </div>

          <div className="terms-section">
            <h2>Pricing and Payment</h2>
            <p>All prices are subject to change without notice. Payment must be made at the time of order placement. We accept various payment methods as indicated during checkout.</p>
          </div>

          <div className="terms-section">
            <h2>Shipping and Delivery</h2>
            <p>We will make every effort to ship your order within the estimated timeframe. However, delivery times may vary due to factors beyond our control. Risk of loss and title for items purchased pass to you upon delivery.</p>
          </div>

          <div className="terms-section">
            <h2>Returns and Refunds</h2>
            <p>We accept returns within 30 days of delivery for most items. Returned items must be in their original condition. Refunds will be processed within 5-7 business days of receiving the returned item.</p>
          </div>

          <div className="terms-section">
            <h2>Intellectual Property</h2>
            <p>The Service and its original content, features, and functionality are and will remain the exclusive property of Inifiy and its licensors. The Service is protected by copyright, trademark, and other laws.</p>
          </div>

          <div className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>In no event shall Inifiy, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.</p>
          </div>

          <div className="terms-section">
            <h2>Governing Law</h2>
            <p>These Terms shall be interpreted and governed by the laws of the jurisdiction in which Inifiy operates, without regard to its conflict of law provisions.</p>
          </div>

          <div className="terms-section">
            <h2>Changes to Terms</h2>
            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.</p>
          </div>

          <div className="terms-section">
            <h2>Contact Information</h2>
            <p>If you have any questions about these Terms of Service, please contact us at:</p>
            <div className="contact-info">
              <p><strong>Email:</strong> legal@inifiy.com</p>
              <p><strong>Address:</strong> 123 E-commerce Street, Digital City, DC 12345</p>
            </div>
          </div>

          <div className="terms-section">
            <h2>Effective Date</h2>
            <p><strong>Last Updated:</strong> January 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 